import { useMemo } from "react";
import styles from "./Invitations.module.css";

export function InvitationCard({ invitation, t, handleAccept, handleDecline }) {
  const avatars = useMemo(() => {
    const map = new Map();
    return (id) => {
      if (!map.has(id)) map.set(id, Math.floor(Math.random() * 4) + 1);
      return map.get(id);
    };
  }, []);

  const getOwnerName = (owner) => owner?.displayName ?? owner?.email ?? owner?.phoneNumber ?? owner?.username ?? "-";

  return (
    <div className={styles.card}>
      <div className={styles.avatarWrap}>
        <img src={`/assets/subscriptions/member${avatars(invitation.id)}.png`} alt="" className={styles.avatar} />
      </div>

      <div className={styles.cardBody}>
        <h3 className={styles.cardName}>{getOwnerName(invitation.ownerId)}</h3>
        <p className={styles.cardText}>
          {t("invited_to_family_group")}
        </p>
        <div className={styles.actions}>
          <button className={`${styles.btn} ${styles.btnJoin}`} onClick={() => handleAccept(invitation)}>
            <img src="/assets/inviters/checked.svg" alt="" width={18} height={18} />
            {t("accept")}
          </button>
          <button className={`${styles.btn} ${styles.btnReject}`} onClick={() => handleDecline(invitation)}>
            <img src="/assets/inviters/cancel.svg" alt="" width={18} height={18} />
            {t("reject")}
          </button>
        </div>
      </div>
    </div>
  );
}